import request from '@/libs/request'

//商品评价 列表
export function goodsCommentsListApi (data) {
  return request({
    url: `goods/goodsComments`,
    method: 'get',
    params: data
  })
}

//商品评价 详情
export function goodsCommentsInfoApi (id) {
  return request({
    url: `goods/goodsComments/` + id,
    method: 'get'
  })
}

//商品评价 删除
export function goodsCommentsDelApi (id) {
  return request({
    url: `goods/goodsComments/` + id,
    method: 'delete'
  })
}


